// import Cookies from "js-cookie";

// eslint-disable-next-line default-param-last,import/prefer-default-export
export function setLocationLogic(cityName, cityData = {}, domains) {
  // const isGoogle = Cookies.get("isGoogle");
  // if (
  //   window.location.hostname.includes("localhost") ||
  //   (window.location.hostname.includes("farkop-") &&
  //     !window.location.hostname.includes("farkop-msk")) ||
  //   window.location.hostname.includes("baltex") ||
  //   isGoogle
  // ) {
  //   window.location.reload();
  //   return;
  // }

  let baseDomain = "farkop.ru";
  if (window.location.hostname.includes("farkop-msk.ru")) {
    baseDomain = "farkop-msk.ru";
  }
  if (window.location.hostname.includes("farkop-seo.ru")) {
    baseDomain = "farkop-seo.ru";
  }
  if (window.location.hostname.includes("farkoplocal.ru")) {
    baseDomain = "farkoplocal.ru";
  }
  if (
    cityName === "Москва" ||
    cityData.region === "Московская" ||
    cityData.region === "Москва"
  ) {
    if (window.location.hostname !== `msk.${baseDomain}`) {
      window.location.href = `https://msk.${baseDomain}${window.location.pathname}${window.location.search}`;
    }
    return;
  }
  if (
    cityName === "Санкт-Петербург" ||
    cityData.region === "Санкт-Петербург" ||
    cityData.region === "Ленинградская"
  ) {
    if (window.location.hostname !== `spb.${baseDomain}`) {
      window.location.href = `https://spb.${baseDomain}${window.location.pathname}${window.location.search}`;
    }
    return;
  }

  // Пока справочник не загрузился, в сторе лежит {} (locationReducer) —
  // не знаем поддомен города, остаёмся где есть, а не уводим на базовый домен
  if (!Array.isArray(domains)) {
    return;
  }

  const domain = domains.find((domain) => domain.name === cityName);

  if (domain) {
    if (window.location.hostname !== `${domain.code}.${baseDomain}`) {
      window.location.href = `https://${domain.code}.${baseDomain}${window.location.pathname}${window.location.search}`;
    }
  } else if (window.location.hostname !== `${baseDomain}`) {
    window.location.href = `https://${baseDomain}${window.location.pathname}${window.location.search}`;
  }
}
